module.exports = __webpack_public_path__ + "media/src/StayPackage/images/home-e70798183fb918fddb17d0a9eaa9219a.svg";